"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/PinCutOut.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var PinCutOut = function PinCutOut(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "solid-icon",
    viewBox: "0 0 194.41 241.67"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Map Pin Icon"), _react2.default.createElement("path", {
    className: "pin-cutout",
    d: "M97.21 0A97.32 97.32 0 0 0 0 97.21c0 12.68 4.16 28 12.37 45.55a292.07 292.07 0 0 0 27.33 45.65 295.76 295.76 0 0 0 30.44 36.25c15.25 15.08 22.47 17 27.06 17s11.49-1.94 26.68-17a305.42 305.42 0 0 0 30.46-36.21c15-20.65 40.07-60 40.07-91.23A97.32 97.32 0 0 0 97.21 0zm0 124.83a41 41 0 1 1 41-41 41 41 0 0 1-41 41z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = PinCutOut;